module.exports = __webpack_public_path__ + "img/poseCVCNutriNeo.48085840.jpg";